( function () {
	/* globals angular */
	'use strict';

	/* eslint no-undef:0 */
	/* eslint max-params:0 */
	function evidencePoolModalController ( $scope, logger, INFO, $modal, moment, EVDICONS,  FILETYPES, Session, evidenceService ) {
		$scope.icons             = EVDICONS;
		$scope.disableOnEditMode = false;

		function deleteEvidence ( evidence ) {
			// this is to delete the timer evidence in timer-directive
			if ( evidence.type === 7 ) {
				$scope.$root.$broadcast( 'delete:timer', evidence.id );
			}

			evidenceService.editDeleteEvidence( evidence, 'delete', $scope.observation );

			$scope.$root.$broadcast( 'check:running:timer:counter', evidence );
		}

		function deleteConfirmationModal ( evidence ) {
			$scope.evidenceFileData = {
				'fileId'   : evidence.url,
				'fileType' : FILETYPES.observation,
				'userId'   : Session.getCredentials().userId
			};

			var modalInstance = $modal.open( {
				'templateUrl'  : '/templates/components/delete-modal/delete-confirmation.html',
				'controller'   : 'DeleteConfirmationController',
				'controllerAs' : 'vm',
				'scope'        : $scope,
				'resolve'      : {
					'type' : function () {
						var type = 'Evidence';

						if ( [ 3, 5 ].indexOf( evidence.type ) > -1 ) {
							type = 'Evidence-file';
						}

						return type;
					}
				}
			} );

			modalInstance.result.then( function () {
				deleteEvidence( evidence );
			} );
		}

		function updateScope ( evidence ) {
			evidenceService.editDeleteEvidence( evidence, 'edit', $scope.observation );
			$scope.update();
		}

		$scope.deleteConfirmationModal = deleteConfirmationModal;
		$scope.deleteEvidence          = deleteEvidence;
		$scope.updateScope             = updateScope;
	}

	angular
		.module( 'app.components' )
		.controller( 'evidencePoolModalController', evidencePoolModalController );

	evidencePoolModalController.$inject = [ '$scope', 'logger', 'INFO', '$modal', 'moment', 'EVDICONS', 'FILETYPES', 'Session', 'evidenceService' ];
} )( );
